import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { globalAudioSaga } from './saga';
import { GlobalAudioState } from './types';

export const initialState: GlobalAudioState = {
  currentSong: undefined,
  isPlaying: false,
  progress: 0,
  seekToProgress: undefined,
  queue: [],
  historyStack: [], // so you can click prev to play prev songs
};

const slice = createSlice({
  name: 'globalAudio',
  initialState,
  reducers: {
    setCurrentSong(state, action: PayloadAction<any>) {
      state.currentSong = action.payload
    },
    setIsPlaying(state, action: PayloadAction<any>) {
      state.isPlaying = action.payload
    },
    setProgress(state, action: PayloadAction<any>) {
      state.progress = action.payload
    },
    setSeekToProgress(state, action: PayloadAction<any>) {
      state.seekToProgress = action.payload
    },
    queueSong(state, action: PayloadAction<any>) {
      let newQueue = state.queue;
      newQueue.push(action.payload)
      state.queue = newQueue;
    },
    addSongToHistoryStack(state, action: PayloadAction<any>) {
      let newStack = state.historyStack;
      newStack.push(action.payload)
      state.historyStack = newStack;
    },
    playNextSongFromQueue(state, action: PayloadAction<any>) {
      let newQueue = state.queue;
      let prevSong = state.currentSong; // For historyStack
      let nextSong = newQueue.shift()
      state.currentSong = nextSong
      state.queue = newQueue;

      // push to historyStack
      let newStack = state.historyStack
      newStack.push(prevSong)
      state.historyStack = newStack
    },
    playPrevSongFromStack(state, action: PayloadAction<any>) {
      // remove prev song from history stack
      let newStack = state.historyStack;
      let currentSong = state.currentSong; // For historyStack
      let newCurrentSong = newStack.pop()
      state.currentSong = newCurrentSong
      state.historyStack = newStack;

      // push current song to front of queue
      let newQueue = state.queue
      newQueue.unshift(currentSong)
      state.queue = newQueue
    },
  },
});

export const { actions: globalAudioActions } = slice;

export const useGlobalAudioSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: globalAudioSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useGlobalAudioSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
